// Basic API utility for Inquiries
// Using fetch to avoid additional dependencies like axios

// Using relative path to leverage package.json "proxy": "http://localhost:4000"
export const BASE_URL = '';

export const createInquiry = async (data) => {
    try {
        const response = await fetch(`${BASE_URL}/api/inquiries`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        return await response.json();
    } catch (error) {
        console.error('Error creating inquiry:', error);
        throw error;
    }
};

export const getInquiryLink = async () => {
    try {
        const response = await fetch(`${BASE_URL}/api/inquiries/link`);
        if (!response.ok) {
            // It's possible 404 if link not set, handle gracefully
            return { url: '' };
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching inquiry link:', error);
        return { url: '' };
    }
};

export const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { 'Authorization': `Bearer ${token}` } : {};
};

export const getInquiries = async (params) => {
    try {
        // Build query string
        const query = new URLSearchParams(params).toString();
        const response = await fetch(`${BASE_URL}/api/inquiries?${query}`, {
            headers: {
                ...getAuthHeaders()
            }
        });

        if (!response.ok) {
            if (response.status === 401) throw new Error('Unauthorized');
            throw new Error('Failed to fetch inquiries');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching inquiries:', error);
        throw error;
    }
};

export const getInquiry = async (id) => {
    try {
        const response = await fetch(`${BASE_URL}/api/inquiries/${id}`, {
            headers: {
                ...getAuthHeaders()
            }
        });
        if (!response.ok) {
            if (response.status === 401) throw new Error('Unauthorized');
            throw new Error('Failed to fetch inquiry detail');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching inquiry:', error);
        throw error;
    }
};

export const updateInquiry = async (id, data) => {
    try {
        const response = await fetch(`${BASE_URL}/api/inquiries/${id}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            if (response.status === 401) throw new Error('Unauthorized');
            throw new Error('Failed to update inquiry');
        }
        return await response.json();
    } catch (error) {
        console.error('Error updating inquiry:', error);
        throw error;
    }
};
